<template>
  <div
    class="button"
    :is="href ? 'a' : 'button'"
    :href="!!href ? href : false"
    :type="!!!href ? type : false"
    :class="getFieldClasses"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <slot>
      {{ label }}
    </slot>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: ""
    },
    href: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    xsmall: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    square: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getFieldClasses() {
      return {
        "h-10 px-4": !this.xsmall && !this.small && !this.large,
        "h-6 px-2": this.xsmall,
        "h-8 px-3": this.small,
        "h-12 px-5": this.large,
        "px-4 text-sm":
          !this.xsmall && !this.small && !this.large && !this.square,
        "px-2 text-xxs": this.xsmall && !this.square,
        "px-3 text-xs": this.small && !this.square,
        "px-5": this.large && !this.square,
        "w-10": !this.xsmall && !this.small && !this.large && this.square,
        "w-6": this.xsmall && this.square,
        "w-8": this.small && this.square,
        "w-12": this.large && this.square,
        "inline-flex items-center justify-center": this.square,
        "rounded-full": this.rounded,
        "is-loading": this.loading,
        "is-disabled": this.disabled
      };
    }
  }
};
</script>

<style scoped>
@keyframes fade {
  0%,
  100% {
    @apply opacity-75;
  }
  50% {
    @apply opacity-25;
  }
}
.button.is-loading {
  animation: fade 2s infinite;
  @apply pointer-events-none;
}
</style>
